import {
  GET_INVITATION_DATA_FAILURE,
  GET_INVITATION_DATA_REQUEST,
  GET_INVITATION_DATA_SUCCESS,
} from "features/friend-refer/redux/types";
import { getInvitationData } from "screens/invitation/request/friend-reffer";

export const fetchInvitationDataRequest = () => ({
  type: GET_INVITATION_DATA_REQUEST,
});
export const fetchInvitationDataSuccess = (payload) => ({
  type: GET_INVITATION_DATA_SUCCESS,
  payload,
});
export const fetchInvitationDataFailure = (error) => ({
  type: GET_INVITATION_DATA_FAILURE,
  error,
});

export const fetchInvitation = (hash) => async (dispatch) => {
  dispatch(fetchInvitationDataRequest());

  getInvitationData(hash)
    .then((res) => {
      if (res.status === 200) {
        dispatch(fetchInvitationDataSuccess(res.data));
      } else {
        throw new Error("API Error");
      }
    })
    .catch((error) => {
      dispatch(fetchInvitationDataFailure(error.message));
    });
};
